import type { ReportComponentProps } from "@qendo/profile/reports";
import { useMemo } from "react";
import { Report } from "~/components/layout/reports/Report";
import { formatDateString, formatMonthDayForHumans } from "~/util/dates";

export const MonthlyReport = ({ report, data, ...reportProps }: ReportComponentProps) => {
    const labels = useMemo(
        () =>
            Object.fromEntries(
                data.points
                    .filter((_val, idx, array) => idx % Math.floor(array.length / 7) === 0)
                    .map(({ date }) => [formatDateString(date), formatMonthDayForHumans(date)]),
            ),
        [data.points],
    );

    return <Report {...reportProps} labels={labels} report={report} data={data} initialSpacing={3} endSpacing={3} />;
};
